import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";

import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './flickity.css';
import Wrapper from './Wrapper';
import Main from './Main';
import Projects from './Projects';
import About from './About';
import Admin from './Admin';
//import test from "./test"

const router = createBrowserRouter([
  {
    path: "/",
    Component: Wrapper,
    children: [
      { index: true, Component: Main },
      { path: "/projects/", Component: Projects },
      { path: "/about/", Component: About },
    ],
    errorElement: <></>
  },
  {
    path: "/admin/",
    Component: Admin,
  },
  /*{ path: "/test/", Component: test }*/
]);

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
